import { render, staticRenderFns } from "./DispatchDetailsView.vue?vue&type=template&id=ff9961cc&scoped=true"
import script from "./DispatchDetailsView.vue?vue&type=script&lang=js"
export * from "./DispatchDetailsView.vue?vue&type=script&lang=js"
import style0 from "./DispatchDetailsView.vue?vue&type=style&index=0&id=ff9961cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9961cc",
  null
  
)

export default component.exports